import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import WhatsAppButton from "@/components/WhatsAppButton";

import { ButtonGoExplore } from "@/components/ButtonGoExplore";
import Art2Section from "@/Sections/Art2Section";
import ArtSection from "@/Sections/ArtSection";
import { ExploreSection } from "@/Sections/ExploreSection";
import { NewArtsSection } from "@/Sections/NewArtsSection";
import AnimatedSection from "@/components/AnimatedSection";
import { ToysSection } from "@/Sections/ToysSection";

const Home = () => {
  const images = [
    "./assets/1.jpg",
    "./assets/1.jpg",
    "./assets/1.jpg",
  ]; // Adicione os caminhos das suas imagens aqui.

  return (
    <main>
      <div className="w-full min-h-screen">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          className="w-full h-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  backgroundImage: `url(${image})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "80vh",
                  margin: "80px auto 0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></div>
            </SwiperSlide>
          ))}
        </Swiper>
        <ButtonGoExplore />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-marfim">
          <h2 className="max-w-96 h-full text-5xl mb-12">
           
          </h2>
         
        </div>
      </div>

      <div id="explore">
        <AnimatedSection>
          <ExploreSection />
        </AnimatedSection>

        {/* Faixa de texto rotativo */}
        <div className="traffic-banner">
          <div className="traffic-banner-content">
            <p className="rotating-text">As Melhores peças para seu carro , você encontra AQUI!</p>
          </div>
        </div>

        <AnimatedSection>
          <NewArtsSection />
        </AnimatedSection>
      </div>

      <AnimatedSection>
        <ArtSection />
      </AnimatedSection>
      <AnimatedSection>
      <ToysSection />
      </AnimatedSection>
      <AnimatedSection>
        <Art2Section />
      </AnimatedSection>
      <WhatsAppButton />
    </main>
  );
};

export default Home;
